import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dietary experiments",
  "description": "",
  "published": "2009-03-10T00:00:00.000Z",
  "redirect_from": ["/blog/dietary-experiments/swizec/1"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few months ago I've spoken about student food going up in price and that I will most probably stop eating student food as a result. I would even find that particular post to link if I had more time to develop this blog and included a search, but alas, no luck.`}</p>
    <p>{`So anyhow, after the leftover student certificates held up for a month and then the exam season started when I was at home all day long and thus had the time and energy to cook real food, I have this weekend finally come to a point where it's time to start depending upon myself for food again. However, I still don't want to buy student certificates because I still think spending that much money on a single meal is rather excessive.`}</p>
    <p>{`But without eating food from the fridge and without going out to eat, what other option am I left with? It just so turns out I have a bunch of protein and protein bars lying around because I usually have a protein shake after working out and used to have half a protein bar for lunch a while back until I got bored with it and was left with a bunch of unused bars.`}</p>
    <p>{`The solution was simple, replace the one regular meal per day with a protein meal. So for some time I will now be eating one protein bar and one protein shake a day, which is supposedly somewhat unhealthy and rather unwise. I'm not sure, that's why it's called an experiment.`}</p>
    <p>{`The potentially biggest problem I'm facing with this whole thing is that the previously described dietary intake plus some tea and perhaps fruit/vegetable for vitamins amounts to only about 700 calories a day, which isn't very much far as I know (recommended is 1500 a day). And somewhat quite interestingly after being on this diet for only two days I've noticed that I get a lot more tired at the gym and need much larger breaks. I also seem to think a little bit slower, but that could be the side-effect of very little caffeine input today.`}</p>
    <p>{`Hopefully this new diet of mine will make me lose some fat off my body while being enough substance to at least sustain muscle mass ... and hopefully I won't, you know, faint or anything.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      